import { getRgObjectsOfType as u, RG_TYPE as d } from "@project-rouge/rg-core";
function c(i, l, n) {
  let o = 0;
  const r = u(i, d.Building);
  for (const t of r) {
    const s = new Set(t.data.levels.filter((e) => e.isPodium).map((e) => e.levelIndex));
    for (const e of s)
      o += l(t, e, n);
  }
  return o;
}
export {
  c as getMetricFromPodiumLevels
};
//# sourceMappingURL=index5.js.map
